import React from 'react';
import VancoGFREstimator from './VancoGFREstimator';
import './App.css';

function App() {
  return <VancoGFREstimator />;
}

export default App;
